const menuTreeData = {
    "code": 200,
    "msg": null,
    "data": [
        {
            "id": 1,
            "createBy": null,
            "createTime": null,
            "lastUpdateBy": null,
            "lastUpdateTime": null,
            "parentId": 0,
            "name": "系统管理",
            "url": null,
            "perms": null,
            "type": 0,
            "icon": "el-icon-setting",
            "orderNum": 0,
            "delFlag": 0,
            "parentName": null,
            "level": 0,
            "children": [
                {
                    "id": 2,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 1,
                    "name": "用户管理",
                    "url": "/sys/user",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-service",
                    "orderNum": 1,
                    "delFlag": 0,
                    "parentName": "系统管理",
                    "level": 1,
                    "children": [
                        {
                            "id": 3,
                            "createBy": null,
                            "createTime": null,
                            "lastUpdateBy": null,
                            "lastUpdateTime": null,
                            "parentId": 2,
                            "name": "查看",
                            "url": null,
                            "perms": "sys:user:view",
                            "type": 2,
                            "icon": null,
                            "orderNum": 0,
                            "delFlag": 0,
                            "parentName": "用户管理",
                            "level": 2,
                            "children": []
                        },
                        {
                            "id": 4,
                            "createBy": null,
                            "createTime": null,
                            "lastUpdateBy": null,
                            "lastUpdateTime": null,
                            "parentId": 2,
                            "name": "新增",
                            "url": null,
                            "perms": "sys:user:add",
                            "type": 2,
                            "icon": null,
                            "orderNum": 0,
                            "delFlag": 0,
                            "parentName": "用户管理",
                            "level": 2,
                            "children": []
                        },
                        {
                            "id": 5,
                            "createBy": null,
                            "createTime": null,
                            "lastUpdateBy": null,
                            "lastUpdateTime": null,
                            "parentId": 2,
                            "name": "修改",
                            "url": null,
                            "perms": "sys:user:edit",
                            "type": 2,
                            "icon": null,
                            "orderNum": 0,
                            "delFlag": 0,
                            "parentName": "用户管理",
                            "level": 2,
                            "children": []
                        },
                        {
                            "id": 6,
                            "createBy": null,
                            "createTime": null,
                            "lastUpdateBy": null,
                            "lastUpdateTime": null,
                            "parentId": 2,
                            "name": "删除",
                            "url": null,
                            "perms": "sys:user:delete",
                            "type": 2,
                            "icon": null,
                            "orderNum": 0,
                            "delFlag": 0,
                            "parentName": "用户管理",
                            "level": 2,
                            "children": []
                        }
                    ]
                },
                {
                    "id": 7,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 1,
                    "name": "企业管理",
                    "url": "/sys/dept",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-news",
                    "orderNum": 2,
                    "delFlag": 0,
                    "parentName": "系统管理",
                    "level": 1,
                    "children": [

                    ]
                },
                {
                    "id": 12,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 1,
                    "name": "角色管理",
                    "url": "/sys/role",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-view",
                    "orderNum": 4,
                    "delFlag": 0,
                    "parentName": "系统管理",
                    "level": 1,
                    "children": [

                    ]
                },
                {
                    "id": 17,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 1,
                    "name": "菜单管理",
                    "url": "/sys/menu",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-menu",
                    "orderNum": 5,
                    "delFlag": 0,
                    "parentName": "系统管理",
                    "level": 1,
                    "children": [

                    ]
                },
                {
                    "id": 27,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 1,
                    "name": "系统配置",
                    "url": "/sys/config",
                    "perms": null,
                    "type": 1,
                    "icon": "el-icon-edit-outline",
                    "orderNum": 7,
                    "delFlag": 0,
                    "parentName": "系统管理",
                    "level": 1,
                    "children": [

                    ]
                }
            ]
        },
        {
            "id": 46,
            "createBy": null,
            "createTime": null,
            "lastUpdateBy": "admin",
            "lastUpdateTime": "2021-07-08T03:04:18.000+0000",
            "parentId": 0,
            "name": "接口文档",
            "url": "http://127.0.0.1:8001/swagger-ui.html",
            "perms": null,
            "type": 1,
            "icon": "el-icon-document",
            "orderNum": 3,
            "delFlag": 0,
            "parentName": null,
            "level": 0,
            "children": [
                {
                    "id": 47,
                    "createBy": null,
                    "createTime": null,
                    "lastUpdateBy": null,
                    "lastUpdateTime": null,
                    "parentId": 46,
                    "name": "查看",
                    "url": null,
                    "perms": "sys:swagger:view",
                    "type": 2,
                    "icon": null,
                    "orderNum": 0,
                    "delFlag": 0,
                    "parentName": "接口文档",
                    "level": 1,
                    "children": []
                }
            ]
        }
    ]
};
export default menuTreeData;


// WEBPACK FOOTER //
// ./src/mock/modules/menu/menutreedata.js